import { RootState } from '@redux/types';
import { FeatureFlag } from './enums';

export const selectFeatureFlag = (
  state: RootState,
  flagName: FeatureFlag,
): boolean => state.featureFlags.flags[flagName] ?? false;
